import { render, staticRenderFns } from "./PageEditorContentNav.vue?vue&type=template&id=623654e6&scoped=true"
import script from "./PageEditorContentNav.vue?vue&type=script&lang=js"
export * from "./PageEditorContentNav.vue?vue&type=script&lang=js"
import style0 from "./PageEditorContentNav.vue?vue&type=style&index=0&id=623654e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623654e6",
  null
  
)

export default component.exports